import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';

export interface ContextMenuOption {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  divider?: boolean;
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  disabled?: boolean;
}

export interface RowContextMenuProps {
  position: { top: number; left: number } | null;
  open: boolean;
  options: ContextMenuOption[];
  onClose: () => void;
}

/**
 * Reusable context menu component for table rows
 * Can be used with any table (patients, users, etc.)
 */
export const RowContextMenu: React.FC<RowContextMenuProps> = ({
  position,
  open,
  options,
  onClose,
}) => {
  return (
    <Menu
      anchorPosition={position || undefined}
      anchorReference="anchorPosition"
      open={open}
      onClose={onClose}
    >
      {options.map((option, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            option.onClick();
            onClose();
          }}
          disabled={option.disabled}
          divider={option.divider}
          sx={{
            color: option.color === 'error' ? 'error.main' : 'inherit',
          }}
        >
          {option.icon && (
            <ListItemIcon sx={{ color: option.color === 'error' ? 'error.main' : 'inherit' }}>
              {option.icon}
            </ListItemIcon>
          )}
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default RowContextMenu;
